export default {
  computed: {
    stateIdDisplayFormat() {
      return this.$store.state.propertiesModule.properties['GENERAL-STATE_ID_DISP_FORMAT'];
    },
  },
  methods: {
    formatStateID(stateId) {
      if (!this.stateIdDisplayFormat || !stateId) return stateId;
      return this.stateIdDisplayFormat.split('-')
        .map((ones, idx, onesArray) => (onesArray.length > idx + 1
          ? stateId.substr(onesArray.slice(0, idx).join('').length, ones.length)
          : stateId.substr(onesArray.slice(0, idx).join('').length)))
        .join('-');
    },
  },
};
